import React from "react";

const BadgeList = ({ list, onClick, listName }) => {
  return (
    <div className="overflow-auto my-2" style={{ maxHeight: "25vh" }}>
      {list.map((item, i) => (
        <span key={i} className="badge badge-pill badge-success mx-1">
          {item[listName]}
          <i className="fas fa-times ml-1" onClick={() => onClick(item)}></i>
        </span>
      ))}
    </div>
  );
};

BadgeList.defaultProps = {
  listName: "name",
};

export default BadgeList;
